module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMTAgMTEwIj48ZGVmcz48c3R5bGU+LmEsLmN7ZmlsbDpub25lfS5ie29wYWNpdHk6LjY3fS5je3N0cm9rZTojZmZmO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6N3B4fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT50cmVuZC1kb3duPC90aXRsZT48cGF0aCBjbGFzcz0iYSIgZD0iTTAgMGgxMTB2MTEwSDB6Ii8+PGcgY2xhc3M9ImIiPjxwYXRoIGNsYXNzPSJjIiBkPSJNOTEuMzYgOTEuMzZMMjAuNjQgMjAuNjRtNzAuNzIgOC40OXY2Mi4yM0gyOS4xMyIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/images/trend-down.svg
// module id = 284
// module chunks = 1